<script>
import Logo from "@/components/Logo";

export default {
  name: "Menu",

  components: {
    Logo,
  },

  data() {
    return {
      active: false,
    };
  },

  created() {
    document.addEventListener("keyup", this.closeOnEsc);
  },

  beforeDestroy() {
    document.removeEventListener("keyup", this.closeOnEsc);
  },

  methods: {
    closeOnEsc() {
      if (event.keyCode === 27) {
        this.active = false;
      }
    },

    close() {
      window.setTimeout(() => {
        this.active = false;
      }, 100);
    },
  },
};
</script>

<template>
  <div>
    <div v-if="active" @click="active = false">
      <Logo />
    </div>

    <button class="menu-button" @click="active = !active" :class="{ active }">
      <div class="line" />
      <div class="line" />
    </button>

    <div class="menu" :class="{ active }">
      <ul>
        <router-link :to="{ name: 'original-design' }" @click.native="close">
          <li>Original design</li>
        </router-link>

        <router-link
          :to="{ name: 'pre-owned-furniture' }"
          @click.native="close"
        >
          <li>Pre-owned furniture</li>
        </router-link>

        <router-link :to="{ name: 'sold-items' }" @click.native="close">
          <li>Sold items</li>
        </router-link>

        <router-link :to="{ name: 'about' }" @click.native="close">
          <li>Services and About</li>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.logo {
  z-index: 999;
}

.menu-button {
  position: fixed;
  top: $space-small;
  right: $space-small;
  z-index: 999;
  width: $menu-width;
  height: $menu-width;
  padding: 0;
  border: 0;
  background: transparent;

  @include medium {
    top: $space-base;
    right: $space-base;
  }

  .line {
    position: absolute;
    top: 0;
    width: 100%;
    border-bottom: 2px solid black;
    transition: 0.15s;

    &:nth-child(2) {
      top: 8px;
    }
  }

  &:hover {
    .line {
      border-color: $blue;
    }
  }

  &.active {
    .line {
      top: 14px;
      transform: rotateZ(45deg);

      &:nth-child(2) {
        transform: rotateZ(-45deg);
      }
    }
  }

  &:active,
  &:focus {
    outline: 0;
  }
}

.menu {
  padding: $space-small;
  z-index: 998;
  display: none;
  background: $orange;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;

  &.active {
    display: flex;
  }

  ul {
    margin-top: 40px;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: white;
  }

  li {
    text-transform: uppercase;
    margin-bottom: 40px;
    font-size: 2rem;
    line-height: 1.3;

    @include small {
      font-size: 2.5rem;
      top: $space-base;
      right: $space-base;
    }
  }
}
</style>
